import {
    QuotationFilter,
    Quotation,
    QuotationHistorical,
} from '../shared/types/modules/quotation';
import { apiService } from './index';
import { ResponseData } from '../shared/types/shared';

export const asyncGetQuotations = async (
    filters: QuotationFilter,
    page?: number,
    pageSize?: number
): Promise<{ items: Quotation[]; length: number }> => {
    try {
        const {
            items: data,
        }: {
            items: { items: Quotation[]; length: number };
        } = await apiService.get('/api/quotation', {
            limit: pageSize || 20,
            page: page || 0,
            ...filters,
        });

        return data || { items: [], length: 0 };
    } catch (error) {
        return { items: [], length: 0 };
    }
};

export const asyncGetQuotation = async (
    idQuotation: string
): Promise<Quotation | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: Quotation;
        } = await apiService.get(`/api/quotation/${idQuotation}`);

        return data;
    } catch (error) {}
};

export const asyncCreateQuotation = async (
    info: Quotation
): Promise<Quotation | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: Quotation;
        } = await apiService.post('/api/quotation', info);
        return data;
    } catch (error) {}
};

export const asyncUpdateQuotation = async (
    id: string,
    quotation: Quotation
): Promise<Quotation | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: Quotation;
        } = await apiService.patch(`/api/quotation/${id}`, quotation);

        return data;
    } catch (error) {}
};

export const asyncSendTemplateQuotation = async (
    quotation: Quotation,
    email: string
): Promise<ResponseData | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: ResponseData;
        } = await apiService.patch(`/api/quotation/send/${email}`, quotation);

        return data;
    } catch (error) {}
};

export const asyncGetQuotationHistorical = async (
    idQuotation: string
): Promise<QuotationHistorical[] | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: QuotationHistorical[];
        } = await apiService.get(`/api/quotation/${idQuotation}/historical`);
        return data;
    } catch (error) {}
};
